import { StrictMode } from "react";
import {
  BrowserRouter as Router,
  useLocation,
} from "react-router-dom";
import { FocusStyleManager, HotkeysProvider } from "@blueprintjs/core";
import { useDarkMode } from "ui-components";
import GlobalStyle from "ui-components/global-style";
import { parseLocation } from "./routes";

import 'react-datepicker/dist/react-datepicker.css';
import "@blueprintjs/core/lib/css/blueprint.css";
// include blueprint-icons.css for icon font support
import "@blueprintjs/icons/lib/css/blueprint-icons.css";

import { QueryClient, QueryClientProvider } from "react-query";
import StyledThemeProvider from "./styled-theme-provider";
// import  from "./components/global-style";
import GlobalErrorBoundary from "ui-components/global-error-boundary";
import Layout from "./components/layout";

// Create a new QueryClient instance
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: Infinity,
      refetchOnWindowFocus: false,
    },
  },
});

const AppWithoutRouter = () => {
  // const sessionState = useSessionState()
  

  const [darkMode] = useDarkMode();
  const location = useLocation();

  return (
    <StyledThemeProvider darkMode={darkMode}>
      <QueryClientProvider client={queryClient}>
        <StrictMode>
          <GlobalStyle />
          <Layout>
            <GlobalErrorBoundary>
              {parseLocation(location.pathname + location.search)}
            </GlobalErrorBoundary>
          </Layout>
        </StrictMode>
      </QueryClientProvider>
    </StyledThemeProvider>
  );
};
const App = () => {
  return (
    <Router>
      <HotkeysProvider>
        <AppWithoutRouter />
      </HotkeysProvider>
    </Router>
  );
};

export default App;